import defaultAttributes from '../defaultAttributes';

const Ruler = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M16 2l6 6L8 22l-6-6L16 2' }],
    ['path', { d: 'M7.5 10.5l2 2' }],
    ['path', { d: 'M10.5 7.5l2 2' }],
    ['path', { d: 'M13.5 4.5l2 2' }],
    ['path', { d: 'M4.5 13.5l2 2' }],
  ],
];

export default Ruler;
